<div class="fc-order-pdp-gallery" fc-skeleton>
    <div #wheelZone class="fc-order-pdp-gallery-content">
        <i
            *ngIf="isSliderActive()"
            (click)="navigateSliderUp()"
            class="fa fa-angle-up fc-order-pdp-gallery-slider-up-arrow"
            [ngClass]="{
                'fc-order-pdp-gallery-arrow-active': isSliderUpArrowActive(),
                'fc-order-pdp-gallery-arrow-disabled': !isSliderUpArrowActive()
            }"
        >
        </i>
        <ul class="fc-order-pdp-gallery-tile-container">
            <li
                *ngFor="let image of displayedImages"
                class="fc-order-pdp-gallery-tile"
                [ngClass]="{ 'fc-order-pdp-gallery-tile-active': isActiveImage(image) }"
                (click)="displayAsActiveImage(image)"
            >
                <img [src]="image.thumbUrl | getSafeImageUrl | async" />
            </li>
        </ul>
        <i
            *ngIf="isSliderActive()"
            (click)="navigateSliderDown()"
            class="fa fa-angle-down"
            [ngClass]="{
                'fc-order-pdp-gallery-arrow-active': isSliderDownArrowActive(),
                'fc-order-pdp-gallery-arrow-disabled': !isSliderDownArrowActive()
            }"
        >
        </i>
    </div>
    <div class="fc-order-pdp-gallery-active-image-container">
        <div *ngIf="discount" class="fc-order-pdp-gallery-discount-badge" #discountBadge>
            <fcp-badge color="promotion" [text]="'- ' + discount + '%'"></fcp-badge>
        </div>
        <ng-container *fcMediaWrapper="'desktop'">
            <div
                [zoom]="zoomEnabled"
                class="fc-order-pdp-gallery-active-image"
                [image]="activeImage.largeUrl | getSafeImageUrl | async"
                (click)="onImageClick()"
                (mouseenter)="hideDiscountBadge()"
                (mouseleave)="showDiscountBadge()"
            ></div>
            <fc-image-dialog
                [modalId]="previewModalId"
                [image]="activeImage.originalUrl | getSafeImageUrl | async"
            ></fc-image-dialog>
        </ng-container>
        <ng-container *fcMediaWrapper="'mobile'">
            <img
                (click)="onImageClick()"
                class="fc-order-pdp-gallery-active-image"
                [src]="activeImage.largeUrl | getSafeImageUrl | async"
            />
            <fc-image-dialog
                [isMobile]="true"
                [modalId]="previewModalId"
                [image]="activeImage.originalUrl | getSafeImageUrl | async"
            ></fc-image-dialog>
        </ng-container>
        <div *ngIf="isPreliminaryImage" class="fc-order-pdp-gallery-active-image-preliminary">
            <fcp-badge size="big" color="warning" [text]="'ORDER.PRODUCT_SEARCH.PRELIMINARY_PRODUCT' | translate">
            </fcp-badge>
        </div>
        <div *ngIf="isActiveImageAI" class="fc-order-pdp-gallery-ai-badge">
            <fcp-tag
                [severity]="TagSeverity.Promotional"
                [emphasis]="TagEmphasis.Subtle"
                [size]="TagSize.Small"
                icon="fal fa-stars"
                value="AI-generated"
            ></fcp-tag>
        </div>
    </div>
</div>
